import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  setVoiceSessionStatus,
  voiceSessionIdSelector,
} from './voiceSessionSlice';

import { VoiceMeetingEventBus } from 'features/voice-meeting/services';
import type { RootState } from 'features/app/store/store';
import { isPrimaryVcoSenderSelector } from 'features/vco/store';
import { VoiceSessionStatus } from 'features/voice-session/enums';
import { VoiceSessionDaoService } from 'features/voice-session/services';

export const deleteVoiceSessionThunk = createAsyncThunk(
  'voiceSession/deleteVoiceSessionThunk',
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;
    const sessionId = voiceSessionIdSelector(state);
    const isPrimaryVcoSender = isPrimaryVcoSenderSelector(state);

    if (!sessionId) {
      return;
    }

    dispatch(setVoiceSessionStatus(VoiceSessionStatus.DISCONNECTING));

    if (isPrimaryVcoSender) {
      try {
        await VoiceSessionDaoService.deleteVoiceSession({
          sessionId,
        });
        VoiceMeetingEventBus.resetVoiceSession$.next();
      } catch (error) {
        // likely a race condition but if we don't delete the voice session, the next call will fail
        console.warn('DEBUG: Error deleting voice session', error);
      }
    }
  }
);
